var productsJson = {};


class BundleForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.bundle_variant_id = this.querySelector('[data-bundle-variant-id]').getAttribute('data-bundle-variant-id');
        this.bundle_product_id = this.querySelector('[data-bundle-product-id]')?.getAttribute('data-bundle-product-id');
    }

    /**
     * Product Form Submit event
     *
     * @param {evt} Event instance
    */
    async onSubmitHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        const submitButton = this.querySelector('[type="submit"]');
        let bundleContents = "";
        if (this.querySelectorAll(".variant-size input:checked").length != this.querySelectorAll('[name="id[]"]').length) {
            submitButton.classList.add('notselected');
            submitButton.querySelector('.add-text').innerHTML = 'Select a size';
            this.querySelectorAll('input[name="id[]"]').forEach((ele)=>{
                if (ele.value == "") {
                    ele.closest('bundle-item')?.querySelector('.product-size-list')?.classList.add('border-red');
                    ele.closest('bundle-item')?.querySelector('[data-error-text]')?.classList.add('show');
                }else{
                    ele.closest('bundle-item')?.querySelector('.product-size-list')?.classList.remove('border-red');
                    ele.closest('bundle-item')?.querySelector('[data-error-text]')?.classList.remove('show');
                }
            })
            setTimeout(async () => {
                submitButton.classList.remove('notselected');
                submitButton.querySelector('.add-text').innerHTML = 'ADD TO BAG';
            }, 1000);
            return false;
        }else{
            submitButton.setAttribute('disabled', true);
            submitButton.classList.add('loading');

            this.querySelectorAll('bundle-item .product-size-list.border-red').forEach((ele)=>{
                ele?.classList.remove('border-red');
                ele.closest('bundle-item')?.querySelector('[data-error-text]')?.classList.remove('show');
            })

            let bundleItem = {
                id: this.bundle_variant_id,
                properties: {}
            };
            let bundleProperties = "";
            let bundleSize = 0;

            let components = this.querySelectorAll('[name="id[]"]');
            let componentLength = components.length;

            let timeStamp = new Date().getTime();
            components.forEach((component, componentIndex)=>{
                let variant_image = component.closest('bundle-item').querySelector('[data-color-swatch]').getAttribute('data-bundle-src')
                bundleSize += 1;
                bundleProperties += `${component.value}:1${componentLength -1 !== componentIndex ? '||' : ''}`;
            })
            if (bundleProperties) {
                bundleItem.properties['_components'] = bundleProperties;
                bundleItem.properties['_bundle_size'] = bundleSize;
                bundleItem.properties['_bundle_product_id'] = this.bundle_product_id;
            }
            const body = JSON.stringify({
                items: [bundleItem]
              });
            fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
            .then((response) => {
                response.json()
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {

                // Stop loading
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('disabled');
            });
            
            setTimeout(() => {
                submitButton.classList.remove('notselected');
                submitButton.querySelector('.add-text').innerHTML = 'ADD TO BAG';
            }, 3000);
        }
    }
}
customElements.define('bundle-form', BundleForm);

class BundleItem extends HTMLElement {
    constructor() {
        super();
        this.currentProductJson = this.querySelector('[type="application/json"]') && JSON.parse(this.querySelector('[type="application/json"]')?.textContent);
        if (this.currentProductJson) {
            productsJson[this.currentProductJson.id] = this.currentProductJson;
            this.querySelectorAll('[type="radio"]').forEach((ele) => ele.addEventListener('change', this._onVariantChange.bind(this)));
            this.querySelectorAll('[data-style-id]').forEach((ele) => ele.addEventListener('click', this._changeColor.bind(this)));
            this.querySelectorAll('[data-style-id]').forEach((ele) => ele.addEventListener('mouseover', this._changeColorText.bind(this)));
            this.querySelectorAll('[data-style-id]').forEach((ele) => ele.addEventListener('mouseout', this._changeColorText.bind(this,'default')));
        }

        this._handleColorSwatchesScroll();
    }

    _onVariantChange=(event)=>{
        this._setCurrentVariant(event);
    }

    _handleColorSwatchesScroll() {
        let scrollableElement = this.querySelector('.bundle-color-swatches');
        this._hideShowScrollArrow('default');
        scrollableElement?.addEventListener('scroll', ()=>{
            this._hideShowScrollArrow('scroll');
        });
        
        this.querySelector('[data-scroll-swatch]')?.addEventListener('click',(event)=>{
            let scrollIcon = event.target.closest('[data-scroll-swatch]');
            if (scrollIcon?.classList.contains('revert')) {
                scrollableElement.scrollTo({
                    left: 0,
                    behavior: 'smooth'
                });
            }else{
                scrollableElement.scrollTo({
                    left: scrollableElement.scrollWidth,
                    behavior: 'smooth'
                });
            }
        })
    }

    _hideShowScrollArrow=(eventType)=>{
        const scrollableLists = this.querySelectorAll('.bundle-color-swatches');
        scrollableLists.forEach(scrollableList => {
            const scrollLeft = scrollableList.scrollLeft+50;
            const scrollWidth = scrollableList.scrollWidth;
            const clientWidth = scrollableList.clientWidth;
            const lastItem = scrollableList.lastElementChild;
            const rightArrow = scrollableList.closest('.bundle-color-swatches-wrapper').querySelector('.right-arrow');
            let isVisible = Utility.isElementVisibleButNotIntersecting(lastItem,scrollableList);
            if (Utility.hasHorizontalScroll(scrollableList) == false) {
                if (rightArrow) {
                    rightArrow.classList.add('d-none');
                    
                }
            } else if (eventType == 'scroll' && isVisible) {
                if (rightArrow) {
                    rightArrow.classList.add('revert');
                }
            } else if(eventType == 'scroll') {
                if (rightArrow) {
                    rightArrow.classList.remove('revert');
                }
            }
        });
    }

    _setCurrentVariant=(event)=>{
        let size = this.querySelector('.variant-size [type="radio"]:checked')?.value || false;
        document.querySelector('[data-selected-product-size]')?.setAttribute('data-selected-product-size',size);
        let color = this.currentProductJson.variants[0].option2;
        let selectedValues = [size,color];
        let currentVariantJson = this.currentProductJson.variants;
        currentVariantJson.find((variant) => {
            let mappedValues = variant.options.map((option, index) => {
                return selectedValues[index] === option;
            });
            if (!mappedValues.includes(false)) {
                this.currentVariant = variant;
            }
        });
        let inputEle = this.querySelector('[name^="id"]');
        if (inputEle) {
            inputEle.setAttribute('data-product-id',this.currentProductJson.id);
            inputEle.setAttribute('data-product-title',this.currentProductJson.title);
            inputEle.value=this.currentVariant?.id || "";
        }

        this._manageOOSColor(size);
        this.updateVariantStatuses(event)
        this.querySelector('[data-style-id].selected')?.click();
    }

    /**
     * Fetch Available options
    */
    updateVariantStatuses(_event) {
        let tempProductJson = this.currentProductJson
        const selectedOptionOneVariants = tempProductJson.variants;
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
        if (index === 2) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
        var previousOptionSelected = inputWrappers[index - 1]?.querySelector(':checked')?.value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => 
        variant.available && variant[`option${ index }`] === previousOptionSelected)
        .map(variantOption => variantOption[`option${index+1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue)
        });
    }

    /**
     * Disabled Unavailable options
     */
    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        let tempProductJson = this.currentProductJson

        let productTags = tempProductJson?.tags || [];
        listOfAvailableOptions=Array.from(new Set(listOfAvailableOptions));

        listOfAvailableOptions = listOfAvailableOptions.filter(availableOption => {
        availableOption = availableOption.toUpperCase();
            return !productTags.includes(`OOS_${availableOption}`);
        })
        listOfOptions.forEach(input => {
            if (input.closest('[name="color"]') == null) {
                if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                    input.closest('li')?.classList.remove('unavailable');
                    input.removeAttribute('disabled');
                } else {
                    input.closest('li')?.classList.add('unavailable');
                    input.setAttribute('disabled',true);
                    if (input?.checked) {
                        input.checked = false;
                    }
                }
            }
        });

    }
    _manageOOSColor=(size)=>{
        this.querySelectorAll('[data-style-id]').forEach((colorSwatch)=>{
            if (colorSwatch.classList.contains(`v-${size}`) || size == false) {
                colorSwatch.classList.remove('size-unavailable');
                colorSwatch.closest('li').classList.remove('order-1');
            } else {
                colorSwatch.classList.add('size-unavailable');
                colorSwatch.closest('li').classList.add('order-1');
            }
        })
    }
    _changeColor=async (event)=>{
        event.preventDefault();
        this.querySelector('[data-style-id].selected')?.classList.remove('selected');
        let selectedSwatch = event.target.closest('[data-style-id]');
        selectedSwatch?.classList.add('selected');
        let productId = selectedSwatch.getAttribute('data-style-id')
        let productUrl = selectedSwatch.getAttribute('href');
        if (productsJson[productId] != undefined) {
            this.currentProductJson = productsJson[productId];
        }else{
            this.currentProductJson = await this._fetchProductData(productUrl);
            this.currentProductJson && (productsJson[productId] = this.currentProductJson);
        }

        // Change Image
        let imgSrc = this.currentProductJson.images[this.currentProductJson.images.length - 1];
        let imgSrc_1 = this.currentProductJson.images[0];

        this.querySelector('[data-color-swatch]').setAttribute('src',imgSrc + '&width=300');
        this.querySelector('[data-color-swatch]').setAttribute('data-bundle-src',imgSrc_1 + '&width=300');


        // Change Color Name
        this._changeColorText('default');
        this._setCurrentVariant();

        if (document.querySelector('[data-product-container]')?.getAttribute('data-product-container') != this.currentProductJson.id) {
            ProductForm.prototype._generateSlider(this.currentProductJson,true)
        }
    }

    _changeColorText=(event)=>{
        let productType = this.querySelector('[data-style-type]')?.getAttribute('data-style-type');
        if (event == 'default') {
            // Change Color Name
            if (this.querySelector('[data-color-name]')) {
                this.querySelector('[data-color-name]').innerHTML = this.querySelector('[data-style-id].selected').getAttribute('title').toLowerCase()
                    .replaceAll(productType.toLowerCase(), '')
                    .replaceAll('boss 2.0', '')
                    .replaceAll('icon 2.0', '')
                    .replaceAll('Rib Tank', '')
                    .replaceAll('rib tank', '')
                    .replaceAll('luxe bralette', '')
                    .replaceAll('u-', '')
                    .replace('4-pack', '').replace('6-pack', '').replace('10-pack', '')
                    .replaceAll('Shorts', '');
            }
        }else{
            let title = event.target.closest('[data-style-id]').querySelector('[title]').getAttribute('title');
            if (this.querySelector('[data-color-name]')) {
                this.querySelector('[data-color-name]').innerHTML = title.toLowerCase()
                    .replaceAll(productType.toLowerCase(), '')
                    .replaceAll('boss 2.0', '')
                    .replaceAll('icon 2.0', '')
                    .replaceAll('Rib Tank', '')
                    .replaceAll('rib tank', '')
                    .replaceAll('luxe bralette', '')
                    .replaceAll('u-', '')
                    .replaceAll('4-pack', '').replaceAll('6-pack', '').replaceAll('10-pack', '')
                    .replaceAll('Shorts', '');
            }
        }
    }
    _fetchProductData=async (url)=>{
        let response= await fetch(`${url}?view=swath.json`);
        let data=await response.json();
        return data;
    }
}

customElements.define('bundle-item', BundleItem);
 
class UpsellItem extends BundleItem{
    constructor() {
        super();
    }
    connectedCallback() {
        // Define variables
        this.sizeWrapper = this.querySelector('[data-size-wrapper]');
        this.upsellInput = this.querySelector('[data-upsell-selection]');
        this.upsellBtn = this.querySelector('[data-upsell-addon]');
        this._bindEvents();
    }

    _bindEvents(){
        this.upsellInput?.addEventListener('change',this._toggleSizeWrapper.bind(this));
        this.sizeWrapper.querySelectorAll('input').forEach(inputEle => inputEle.addEventListener('change', this._manageUpsellAddBtn.bind(this)));
        this.upsellBtn?.addEventListener('click',this._addToBag.bind(this));
    }

    _manageUpsellAddBtn(event){
        this.upsellBtn?.classList.remove('disabled');
        this.querySelector('[data-upsell-addon] .add-text').innerHTML = "Add to bag"
    }

    _toggleSizeWrapper(){
        this.sizeWrapper?.classList.toggle('show');
    }

    async _addToBag(){
        let selectedOption = this.querySelector('[data-selection-option] [data-type="content"] .variant-size.selected [data-upsell-id]');
        let id = selectedOption?.getAttribute('data-upsell-id');
        let productId = selectedOption?.getAttribute('data-upsell-product-id');
        this.upsellBtn?.classList.add('loading');
        let type = this.querySelector('[data-upsell-item-type]').getAttribute('data-upsell-item-type');
        let upsellProperty = '_product_recommendation_same_style_pdp';
        if(type == 'set') {
          upsellProperty = '_product_recommendation_matching_set_pdp';
        }
        let properties = {
          "_upsell": true
        };
        properties[upsellProperty] = true;
        let formData = {
            'items': [{
                id : id,
                quantity: 1,
                properties: properties
            }],
            sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header`
        };

        try {
            var bundleItem = [];
            if (this.querySelector('[data-bundle-pack-reco]')) {
                let selectedSize = selectedOption?.getAttribute('value');
                let packVariantId = id;
                const bundlePackScript = this.querySelector('script[data-bundle-componentRecoJson]');

                bundleItem = {
                    id: packVariantId,
                    properties: {}
                };
                let bundleProperties = "";
                let bundleSize = 0;

                const components = JSON.parse(bundlePackScript.innerHTML);
                let componentLength = components.length;

                components.forEach((component, componentIndex) => {
                    const matchingVariant = component.variants.find(v => v.option === selectedSize);
                    const variantId = matchingVariant?.id;

                    if (variantId) {
                        bundleSize += parseInt(component.quantity || 1);
                        bundleProperties += `${variantId}:${component.quantity || 1}${componentLength -1 !== componentIndex ? '||' : ''}`;
                    } else {
                        console.warn(`No matching variant for size "${selectedSize}" in product ${component.product_id}`);
                    }
                });

                if (bundleProperties) {
                    bundleItem.properties[upsellProperty] = true;
                    bundleItem.properties['_components'] = bundleProperties;
                    bundleItem.properties['_bundle_size'] = bundleSize;
                    bundleItem.properties['_bundle_product_id'] = productId;
                }
                formData = { 'items': [bundleItem] };
            }
        } catch (e) {
            console.log(e)
        }

        let response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
        let data = await response.text();
        let dataJSON = ((typeof data == 'object') ? data : JSON.parse(data));
        let cartFormEle = document.querySelector('cart-form');
        if (cartFormEle) {
            cartFormEle._updateCart(dataJSON.sections, 'open_drawer');
        }
        this.upsellBtn?.classList.remove('loading');
    }
}

customElements.define('upsell-item', UpsellItem);